export const lblCheckCouponHeading = 'lbl_csh_check_coupon_heading';
export const lblTryAnotherCoupon = 'lbl_csh_try_another_coupon';
export const lblCheckCouponDescription = 'lbl_csh_check_coupon_description';
export const checkCouponPlaceholder = 'lbl_csh_check_coupon_placeholder';
export const lblCshValidate = 'lbl_csh_validate';
export const lblCouponCustomerCare = 'lbl_csh_coupon_customer_care';

export const CheckCouponLabels = {
  account: {
    orders: {
      [lblCheckCouponHeading]: 'VALIDATE OFFER',
      [lblTryAnotherCoupon]: 'Try Another Code',
      [lblCheckCouponDescription]: 'Check the redemption details of a coupon/promo code.',
      [checkCouponPlaceholder]: 'Enter Code',
      [lblCshValidate]: 'VALIDATE',
      [lblCouponCustomerCare]: 'Connect with Our Customer Care',
    },
  },
};
